<template>
    <date-picker
        v-model="valueData"
        :format="getDateTimeFormat()"
        lang="en"
        input-class="form-control bg-white"
        :editable="false"
        :type="type"
        :minute-step="minuteStep"
        :clearable="clearable"
        :confirm="confirm"
        @input="updateValue"
        :placeholder="placeholder"
    />
</template>

<script>
import DatePicker from 'vue2-datepicker';
import { formatServerTime } from '../filters/datetime';
import 'vue2-datepicker/index.css';

export default {
    components: {
        DatePicker
    },
    props: {
        type: {
            type: String,
            default: 'date'
        },
        clearable: {
            type: Boolean,
            default: true
        },
        confirm: {
            type: Boolean,
            default: false
        },
        // v-model
        value: {
            type: Object | String,
            default: null
        },
        placeholder: {
            type: String,
            default: 'Chọn thời gian'
        }
    },
    mounted() {
        this.valueData = this.value ? this.$moment(this.value) : null;
        this.updateValue();
    },
    data() {
        return {
            valueData: this.value ? this.$moment(this.value) : null,
            minuteStep: 1
        };
    },
    watch: {
        value(val) {
            this.valueData = val ? this.$moment(val) : null;
            this.updateValue();
        }
    },
    methods: {
        updateValue() {
            const formattedVal = formatServerTime(this.valueData, this.getDateTimeFormat());
            this.$emit('updateValue', formattedVal);
            this.$emit('input', formattedVal); // Update v-model
        },
        getDateTimeFormat() {
            switch (this.type) {
                case 'date':
                    return 'DD/MM/YYYY';
                case 'month':
                    return 'MM/YYYY';
                case 'year':
                    return 'YYYY';
                case 'datetime':
                    return 'DD/MM/YYYY HH:mm';
                default:
                    return 'DD/MM/YYYY';
            }
        }
    }
};
</script>
